module.exports = __webpack_public_path__ + "img/animoca.faca3a40.png";